// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableLayout {
  table-layout: auto;
  width: 100%;
}
table, th, td {
  border: 1px solid #dee2e6;
  border-collapse: collapse;
  padding: 4px;
  font-weight:normal;
}

.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {
  color: #fff;
  background-color: #17a2b8;
  border-color: #dee2e6 #dee2e6 #fff;
}

.nav-tabs .nav-link {
  color: #818182;
}
`, "",{"version":3,"sources":["webpack://./src/app/offer/ancestors/ancestors.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".tableLayout {\r\n  table-layout: auto;\r\n  width: 100%;\r\n}\r\ntable, th, td {\r\n  border: 1px solid #dee2e6;\r\n  border-collapse: collapse;\r\n  padding: 4px;\r\n  font-weight:normal;\r\n}\r\n\r\n.nav-tabs .nav-item.show .nav-link, .nav-tabs .nav-link.active {\r\n  color: #fff;\r\n  background-color: #17a2b8;\r\n  border-color: #dee2e6 #dee2e6 #fff;\r\n}\r\n\r\n.nav-tabs .nav-link {\r\n  color: #818182;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
